import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { WorkOrderRawDto } from './work-order-raw-dto';
import { WorkOrderResponsibleUsersResultDto } from './work-order-responsible-users-result-dto';

export class WorkOrderEditorResultDto {
    @Type(() => WorkOrderRawDto)
    workOrder: WorkOrderRawDto;

    @Type(() => KeyValueResultDto)
    statusList: Array<KeyValueResultDto>;

    @Type(() => KeyValueResultDto)
    priorityList: Array<KeyValueResultDto>;

    @Type(() => KeyValueResultDto)
    jobTypeList: Array<KeyValueResultDto>;

    @Type(() => KeyValueResultDto)
    referenceTypeList: Array<KeyValueResultDto>;

    @Type(() => KeyValueResultDto)
    serviceCodeList: Array<KeyValueResultDto>;

    @Type(() => WorkOrderResponsibleUsersResultDto)
    responsibleList: Array<WorkOrderResponsibleUsersResultDto>;

    @Type(() => Date)
    createdDate: Date;

    createdBy: string;
    hasNotes: boolean;
    allowNewNotes: boolean;
}
